angular.module("avant.customer_applications.factories").factory "AmountPassword", ->

  complexPasswordConditionsMet = (model, input, data) ->
    return false unless input
    params = model.parameter
    isValidPassword = true
    for condition, value of params
      return true unless !!value
      isValidPassword = passwordConditions[condition](value, input, data)
      unless isValidPassword
        return false
    return true

  allowedCharacters = (value, input, _data) ->
    re = new RegExp(value)
    return re.test(input)

  alphabeticRequired = (_value, input, _data) ->
    re = /[A-Za-z]/
    return re.test(input)

  cannotMatchEmail = (_value, input, data) ->
    email = data.email
    if email && email.includes('@')
      emailArr = email.split('@')
      userName = emailArr[0]
      return !(input.toUpperCase().match userName.toUpperCase())
    else
      return true

  lowerRequired = (_value, input, _data) ->
    re = /[a-z]/
    return re.test(input)

  minLength = (value, input, _data) ->
    return input.length >= value

  maxLength = (value, input, _data) ->
    return input.length <= value

  numberRequired = (_value, input, _data) ->
    re = /[0-9]/
    return re.test(input)

  spacesNotAllowed = (_value, input, _data) ->
    re = /^\S*$/
    return re.test(input)

  threeConsecutiveCharactersNotAllowed = (_value, input, _data) ->
    re = /(.)\1{2}/
    return !re.test(input)

  upperRequired = (_value, input, _data) ->
    re = /[A-Z]/
    return re.test(input)

  passwordConditions =
    allowed_characters: allowedCharacters
    alphabetic_required: alphabeticRequired
    cannot_match_email: cannotMatchEmail
    lower_required: lowerRequired
    min_length: minLength
    max_length: maxLength
    number_required: numberRequired
    spaces_not_allowed: spacesNotAllowed
    three_consecutive_characters_not_allowed: threeConsecutiveCharactersNotAllowed
    upper_required: upperRequired

  return {
    complexPasswordConditionsMet: complexPasswordConditionsMet
  }
